import {formatNumber} from '../../../../helpers'

type Props = {
  className: string
  description: string
  stats: string | null
  diff_per?: number
}

const CardsWidget7 = ({className, description, stats, diff_per = 0}: Props) => (
  <div className={`card ${className}`}>
    <div className='card-header pt-2 pe-2 justify-content-end'>
      <div className='card-title d-flex flex-column'>
        <div className='card-title d-flex flex-column align-items-end'>
          <div className='d-flex align-items-center'>
            <span
              className='text-dark me-2 lh-1'
              style={{
                fontSize: '14px',
                fontWeight: '800',
              }}
            >
              {stats ?? '-'}
            </span>
            {description === 'Difference' ? (
              <>
                {diff_per >= 0 ? (
                  <div className='m-0 ms-1 p-0'>
                    <span
                      className='bg-light-success d-flex align-items-center pt-1 ps-2 pb-1 pe-2'
                      style={{
                        fontSize: '0.85rem',
                      }}
                    >
                      <i
                        className='fa-solid fa-angle-up text-success'
                        style={{
                          fontSize: '0.85rem',
                        }}
                      ></i>
                      <span className='text-success ms-1'>
                        {formatNumber(diff_per, 'en-IN', 1, 1)}%
                      </span>
                    </span>
                  </div>
                ) : (
                  <div className='m-0 ms-1 p-0'>
                    <span
                      className='bg-light-danger d-flex align-items-center pt-1 ps-2 pb-1 pe-2'
                      style={{
                        fontSize: '0.85rem',
                      }}
                    >
                      <i
                        className='fa-solid fa-angle-down text-danger'
                        style={{
                          fontSize: '0.85rem',
                        }}
                      ></i>
                      <span className='text-danger ms-1'>
                        {formatNumber(diff_per, 'en-IN', 1, 1)}%
                      </span>
                    </span>
                  </div>
                )}
              </>
            ) : null}
          </div>
          <span
            className='pt-1 text-primary'
            style={{
              fontSize: '12px',
              fontWeight: '600',
            }}
          >
            {description}
          </span>
        </div>
      </div>
    </div>
  </div>
)
export {CardsWidget7}
